

// DashboardContent.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import UsersPage from './UsersPage';
import MessagesPage from './MessagesPage';
import { RiLiveFill } from 'react-icons/ri';
import { useNavigate } from 'react-router-dom';
import InstallButton from './InstallButton';


const DashboardContent = ({ setActivePage }) => {
  const [stats, setStats] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    axios.get('/api/v1/admin/dashboard-stats', { withCredentials: true })
      .then(res => {
        const { users, messages, conversations } = res.data;
        setStats([
          { number: users, label: 'Users' },
          { number: messages, label: 'Messages' },
          { number: conversations, label: 'Conversations' }
        ]);
      })
      .catch(err => console.error(err));
  }, []);

  return (
    <div className="flex flex-col h-screen w-full relative">
             <div className="fixed top-6 right-8 z-50 flex items-center gap-2">
        <div className="relative">
          <InstallButton />
        </div>
        <button 
          onClick={() => setActivePage('livechat')}
          className="bg-green-700 border border-gray-200 text-white p-2 rounded-lg shadow-sm hover:shadow-md 
                    transition-all duration-200 flex items-center justify-center hover:bg-green-500 group"
          title="Live Chat Support"
        >
          <RiLiveFill className="text-xl" />
          <span className="ml-2 text-sm font-medium hidden sm:inline">Chat</span>
        </button>
      </div>
            
      {/* <button 
        onClick={() => setActivePage('livechat')}
        className="fixed top-6 right-8 z-50 bg-green-700 border border-gray-200 text-white p-2 rounded-lg shadow-sm hover:shadow-md transition-all duration-200 flex items-center justify-center hover:bg-green-500 group"
        title="Live Chat Support"
      >
        <RiLiveFill className="text-xl" />
        <span className="ml-2 text-sm font-medium hidden sm:inline">Chat</span>
      </button> */}


      {/* Main scrollable container */}
      <div className="flex-1 overflow-y-auto w-full pr-0">
        {/* Stats Section */}
        <div className="bg-gray-100 p-8 w-full">
          <h1 className="text-3xl font-semibold">Dashboard</h1>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mt-4 w-full">
            {stats.map((item, idx) => (
              <div key={idx} className="bg-white p-6 rounded-xl shadow w-full">
                <h2 className="text-2xl font-bold">{item.number}</h2>
                <p className="text-gray-500 mt-1">{item.label}</p>
              </div>
            ))}
          </div>
        </div>

       
        {/* <div className="bg-white p-6 mx-8 my-4 rounded-xl shadow w-[calc(100%-4rem)]">
          <UsersPage />
        </div> */}
             <UsersPage />
     
        {/* <div className="bg-white p-6 mx-8 my-4 rounded-xl shadow w-[calc(100%-4rem)]">
          <MessagesPage />
        </div> */}
         <MessagesPage />
      </div>
      </div>
  
  );
};

export default DashboardContent;